module.exports = __webpack_public_path__ + "static/media/10_digginglight.87496ef0.jpg";